namespace GeniuzPOS.Inventory {
    export interface IcStockReturnOutForm {
        SysDocNo: Serenity.StringEditor;
        DocNo: GrLookupcustom;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        WhsId: Serenity.LookupEditor;
        StockTo: Serenity.LookupEditor;
        PostFg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        Remark: Serenity.TextAreaEditor;
        CheckQty: Serenity.StringEditor;
        ReturnOutDtList: IcStockReturnOutDtEditor;
    }

    export class IcStockReturnOutForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockReturnOut';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockReturnOutForm.init)  {
                IcStockReturnOutForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = GrLookupcustom;
                var w2 = s.DateEditor;
                var w3 = s.LookupEditor;
                var w4 = s.EnumEditor;
                var w5 = s.TextAreaEditor;
                var w6 = IcStockReturnOutDtEditor;

                Q.initFormType(IcStockReturnOutForm, [
                    'SysDocNo', w0,
                    'DocNo', w1,
                    'DocDate', w2,
                    'RefDocNo1', w0,
                    'RefDocNo2', w0,
                    'WhsId', w3,
                    'StockTo', w3,
                    'PostFg', w4,
                    'CancelFg', w4,
                    'Remark', w5,
                    'CheckQty', w0,
                    'ReturnOutDtList', w6
                ]);
            }
        }
    }
}
